import {
    ResultItem,
    SkuSearchResultsDocumentTypes,
    SkuSearchResultsTransformed,
    SkuSearchResultsType,
} from '@common/types/search';
import { api } from '@services/api';
import { getDocumentDownloadPath } from '@utils/documentDownload';

const productsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getProductBySku: builder.query<SkuSearchResultsTransformed | undefined, string>({
            query: (sku) => `public/products/sku/${sku}?format=json`,
            providesTags: (_result, _error, sku) => [{ type: 'ProductBySku', id: sku }],
            transformResponse: (response: SkuSearchResultsType[]): SkuSearchResultsTransformed | undefined => {
                const product = response[0];
                if (!product) return undefined;
                return {
                    ...product,
                    documents: (product.documents ?? []).reduce<
                        Partial<Record<SkuSearchResultsDocumentTypes, ResultItem[]>>
                    >((acc, doc) => {
                        if (
                            Object.values(SkuSearchResultsDocumentTypes).includes(
                                doc.document_type as SkuSearchResultsDocumentTypes
                            )
                        ) {
                            const key = doc.document_type as SkuSearchResultsDocumentTypes;
                            const ext = doc.url.split('.').pop()?.split('?')[0].toUpperCase();
                            (acc[key] ??= []).push({
                                title: doc.name,
                                url: { href: getDocumentDownloadPath(doc.url) },
                                type: ext,
                            });
                        }
                        return acc;
                    }, {}),
                };
            },
        }),
    }),
});

export const { useGetProductBySkuQuery } = productsApi;
export default productsApi;
